//@ts-ignore
import React, { useContext, useRef } from 'react';
import { graphql } from 'gatsby';
import * as styles from './customer-testimonial.module.css';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { getLangPrefix } from '../../global/countries';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';

import './Testimonial-carousel.css';
import {
    KontentStringValue,
    KontentRadioMultiChoice,
    BrandColor,
    KontentNumberValue,
} from '../../../types/KontentProps';
import { getColor, getMultiChoice } from '../Global/DataUtils';
import { CustomerTestimonialCardsStackView } from './CustomerTestimonialCardsStackView';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/virtual';
import { Navigation, Pagination, Virtual } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import SvgDownArrowSm from '../Global/ShowMoreArrow/SvgDownArrowSm';

interface Testimonial {
    testimonial_copy?: KontentStringValue;
    testimonial_name?: KontentStringValue;
}

interface TestimonialDetail {
    elements: Testimonial;
}

interface Testimonials {
    value: TestimonialDetail[];
}

interface Props {
    kontentItemId?: string;
    headline_copy?: KontentStringValue;
    eyebrow_copy?: KontentStringValue;
    description_copy?: KontentStringValue;
    testimonial_link?: any;
    testimonial_link_copy?: KontentStringValue;
    number_of_cards_to_display_on_mobile?: KontentNumberValue;
    cta_anchor?: KontentStringValue;
    cta_target?: KontentRadioMultiChoice<string>;
    reveal_more__copy?: KontentStringValue;
    testimonials: Testimonials;
    mobile_view?: KontentRadioMultiChoice<'stacked' | 'carousel'>;
    testimonial_color_1?: BrandColor;
    testimonial_text_color_1?: BrandColor;
    testimonial_color_2?: BrandColor;
    testimonial_text_color_2?: BrandColor;
    carousel_arrow_colors?: BrandColor;
    control_bottom_margin?: KontentRadioMultiChoice<string>;
    desktop_bottom_margin?: KontentStringValue;
    mobile_bottom_margin?: KontentStringValue;
}

const ProductTestimonial: React.FC<Props> = ({
    headline_copy,
    eyebrow_copy,
    description_copy,
    testimonial_link,
    testimonial_link_copy,
    number_of_cards_to_display_on_mobile,
    cta_anchor,
    cta_target,
    reveal_more__copy,
    testimonials,
    mobile_view,
    testimonial_color_1,
    testimonial_text_color_1,
    testimonial_color_2,
    testimonial_text_color_2,
    carousel_arrow_colors,
    control_bottom_margin,
    desktop_bottom_margin,
    mobile_bottom_margin,
    kontentItemId,
}) => {
    const controlMargin = control_bottom_margin?.value?.[0]?.codename === 'yes';
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const breakpoints = useBreakpoint();
    const CardOddBackColor = getColor(testimonial_color_1);
    const CardOddTextColor = getColor(testimonial_text_color_1);
    const CardEvenBackColor = getColor(testimonial_color_2);
    const CardEvenTextColor = getColor(testimonial_text_color_2);
    const CarouselArrowColor = getColor(carousel_arrow_colors);
    const pageMetadata = useContext(PageMetadataContext);
    const ctaAnchor = cta_anchor?.value;
    const ctaTarget =
        getMultiChoice(cta_target) === 'same_window' ? '_self' : '_blank';

    const langPrefix = getLangPrefix(pageMetadata?.preferredLanguage);
    const testimonialLink = testimonial_link?.value[0]?.elements?.slug?.url;
    const testimonialUpdatedLink = `${langPrefix}${testimonialLink}${
        ctaAnchor ? `#${ctaAnchor}` : ''
    }`;

    const modifiedProducts = {
        value: testimonials.value.map((cardDetail: TestimonialDetail) => {
            const card = cardDetail.elements;
            return {
                productName: card?.testimonial_name?.value,
                testimonialCopy: card?.testimonial_copy?.value,
            };
        }),
    };
    const uniqueId = `swiper-${Math.random().toString(36)?.substr(2, 9)}`;
    const headlineText = headline_copy?.value;
    const noOfCardsToDisplayOnMobile =
        number_of_cards_to_display_on_mobile?.value;
    const revealMoreText = reveal_more__copy?.value;
    const isMobileViewTypeStack = mobile_view?.value[0]?.codename == 'stacked';
    const marginStyles = controlMargin
        ? {
              marginBottom: breakpoints.md
                  ? `${desktop_bottom_margin?.value || 0}px`
                  : `${mobile_bottom_margin?.value || 0}px`,
          }
        : {};
    const ProductCardsCarouselView = () => {
        return (
            <>
                <style>{`
                   .containerC{
            .swiper-slide-active,
            .swiper-slide-active ~ .swiper-slide-next ~ .swiper-slide {
             @media screen and (min-width: 850px) {
                  margin: 2rem 0;
                }
            }
            .swiper-slide {
                transition: background-color 0.5s ease; /* Adjust the duration as needed */
            } 
            .swiper-slide-active ~ .swiper-slide-next {
            background-color: ${CardEvenBackColor};
            color:${CardEvenTextColor};
             svg polyline {
             stroke: ${CardEvenTextColor};
            }
             a:hover{
            svg polyline {
             stroke: #f06623;
            }}
            margin: 0rem;
          }
    
          .swiper-slide-active, .swiper-slide-active ~ .swiper-slide-next ~ .swiper-slide {
            background-color: ${CardOddBackColor};
            color:${CardOddTextColor};
            svg polyline {
             stroke: ${CardOddTextColor};
            }
            a:hover{
            svg polyline {
             stroke: #f06623;
            }}
          }
  
          @media screen and (max-width:580px){
          .even-slide {
            background-color: ${CardEvenBackColor};
            color:${CardEvenTextColor};
             svg polyline {
             stroke: ${CardEvenTextColor};
            }
             a:hover{
            svg polyline {
             stroke: #f06623;
            }}
            margin: 0rem;
          }
    
          .odd-slide {
            background-color: ${CardOddBackColor};
            color:${CardOddTextColor};
            svg polyline {
             stroke: ${CardOddTextColor};
            }
            a:hover{
            svg polyline {
             stroke: #f06623;
            }}
          }
          }
        .cutomNext:hover,.cutomNext,
        .cutomPrev,
        .cutomPrev:hover,
        .cutomNext:active,
        .cutomPrev:active {
            color: ${CarouselArrowColor} !important;
            }
        .swiper-pagination-bullet-active {
            background-color: ${CarouselArrowColor} !important;
            }   
    }
                    `}</style>
                <div className={styles.containerWrapper}>
                    <div className="containerC">
                        <div
                            className="swiper-button-prev cutomPrev"
                            id={`swiper-prev-${uniqueId}`}
                            ref={prevRef}
                        ></div>

                        <Swiper
                            className="customSwiper"
                            modules={[Virtual, Navigation, Pagination]}
                            centerInsufficientSlides
                            virtual
                            spaceBetween={10}
                            navigation={{
                                nextEl: `#swiper-next-${uniqueId}`,
                                prevEl: `#swiper-prev-${uniqueId}`,
                            }}
                            pagination={{
                                type: 'bullets',
                                enabled: true,
                                clickable: true,
                            }}
                            slidesPerView={!breakpoints.sm ? 1 : 3}
                            scrollbar={{ draggable: true }}
                            breakpoints={{
                                390: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                580: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                750: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                850: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                1000: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                            }}
                        >
                            {modifiedProducts.value.length &&
                                modifiedProducts.value.map((card, idx) => {
                                    const slideClass =
                                        idx % 2 === 0
                                            ? 'odd-slide'
                                            : 'even-slide';
                                    return (
                                        <SwiperSlide
                                            virtualIndex={idx}
                                            key={idx}
                                            className="customSlide"
                                        >
                                            <div
                                                className={`${styles.card} ${slideClass}`}
                                            >
                                                {card.testimonialCopy && (
                                                    <p
                                                        className={
                                                            styles.testimonialCopy
                                                        }
                                                        data-kontent-element-codename="testimonial_copy"
                                                    >
                                                        {card.testimonialCopy}
                                                    </p>
                                                )}
                                                {card.productName && (
                                                    <p
                                                        className={styles.name}
                                                        data-kontent-element-codename="testimonial_name"
                                                    >
                                                        {card.productName}
                                                    </p>
                                                )}
                                                {testimonial_link.value &&
                                                    testimonial_link_copy?.value && (
                                                        <div>
                                                            <p>
                                                                <a
                                                                    target={
                                                                        ctaTarget
                                                                    }
                                                                    href={
                                                                        testimonialUpdatedLink
                                                                    }
                                                                    rel={
                                                                        ctaTarget ===
                                                                        '_blank'
                                                                            ? 'noopener noreferrer'
                                                                            : undefined
                                                                    }
                                                                    className={
                                                                        styles.cta
                                                                    }
                                                                    data-kontent-element-codename="testimonial_link_copy"
                                                                >
                                                                    {
                                                                        testimonial_link_copy?.value
                                                                    }

                                                                    <p
                                                                        style={{
                                                                            width: '11px',
                                                                        }}
                                                                        className={
                                                                            styles.ctaArrow
                                                                        }
                                                                    >
                                                                        <SvgDownArrowSm
                                                                            strokeWidth={
                                                                                3
                                                                            }
                                                                        />
                                                                    </p>
                                                                </a>
                                                            </p>
                                                        </div>
                                                    )}
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                        <div
                            className="swiper-button-next cutomNext"
                            id={`swiper-next-${uniqueId}`}
                            ref={nextRef}
                        ></div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div
                className={styles.wrapper}
                style={marginStyles}
                data-kontent-item-id={kontentItemId}
            >
                <div className={styles.headingContent}>
                    {eyebrow_copy?.value && (
                        <p
                            style={{
                                marginTop: '0.5rem',
                                marginBottom: '0.5rem',
                            }}
                            data-kontent-element-codename="eyebrow_copy"
                        >
                            {' '}
                            {eyebrow_copy?.value}
                        </p>
                    )}
                    {headlineText && (
                        <h3
                            className={styles.headingText}
                            data-kontent-element-codename="headline_copy"
                        >
                            {headlineText}
                        </h3>
                    )}
                    {description_copy?.value && (
                        <p
                            style={{
                                marginTop: '0.5rem',
                                marginBottom: '0.5rem',
                            }}
                            data-kontent-element-codename="description_copy"
                        >
                            {description_copy?.value}
                        </p>
                    )}
                </div>
                {!breakpoints.sm && isMobileViewTypeStack ? (
                    <CustomerTestimonialCardsStackView
                        noOfCardsToDisplayOnMobile={
                            noOfCardsToDisplayOnMobile ||
                            modifiedProducts.value.length > 3
                                ? 3
                                : modifiedProducts.value.length
                        }
                        modifiedProducts={modifiedProducts}
                        revealMoreText={revealMoreText}
                        ctaTarget={ctaTarget}
                        testimonialLink={testimonialUpdatedLink}
                        testimonialCopy={testimonial_link_copy?.value || ''}
                        textColor={CardOddTextColor}
                        backgroundColorr={CardOddBackColor}
                        textColorEven={CardEvenTextColor}
                        backgroundColorrEven={CardEvenBackColor}
                        controlMargin={controlMargin}
                    />
                ) : (
                    <ProductCardsCarouselView />
                )}
            </div>
        </>
    );
};

export default ProductTestimonial;

export const fragmentProductTestimonial = graphql`
    fragment CustomerTestimonial on kontent_item_component___customer_testimonials {
        id
        system {
            id
            codename
        }
        elements {
            control_bottom_margin {
                value {
                    name
                    codename
                }
            }
            mobile_bottom_margin {
                value
            }
            desktop_bottom_margin {
                value
            }
            headline_copy {
                value
            }
            eyebrow_copy {
                value
            }
            description_copy {
                value
            }
            reveal_more__copy {
                value
            }
            testimonial_link_copy {
                value
            }
            testimonial_link {
                value {
                    ... on kontent_item_layout___master_page {
                        id
                        elements {
                            slug {
                                url
                            }
                        }
                    }
                }
            }
            cta_anchor {
                value
            }
            cta_target {
                value {
                    codename
                    name
                }
            }
            number_of_cards_to_display_on_mobile {
                value
            }
            mobile_view {
                value {
                    codename
                }
            }
            testimonial_color_1 {
                ...kontentColor
            }
            testimonial_text_color_1 {
                ...kontentColor
            }
            testimonial_color_2 {
                ...kontentColor
            }
            testimonial_text_color_2 {
                ...kontentColor
            }
            carousel_arrow_colors {
                ...kontentColor
            }
            testimonials {
                value {
                    ... on kontent_item_content_item___customer_testimonial_card {
                        id
                        elements {
                            testimonial_copy {
                                value
                            }
                            testimonial_name {
                                value
                            }
                        }
                    }
                }
            }
        }
    }
`;
